import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { EmptySet, Item } from 'basic-components';

import { Else, If, Then } from 'react-if';

const ProviderItem = ({ provider, onChangeProvider }) => {
  const source = useSelector(state => state.globalState.source),
        onChange = useCallback(({ value }) => onChangeProvider(value), [onChangeProvider])
  return (
    <Item
        checked={provider.name === source}
        key={`${provider.producerId}`}
        onClick={onChange}
        type="checkbox"
        value={provider.name}
    >
      <div className="provider-selector__menu__item__icon">
        <If condition={provider?.iconUrl}>
          <Then>
            {() => (
              <img
                  alt={`${provider?.readableName} Source`}
                  src={provider.iconUrl}
                  width="12px"
              />
            )}
          </Then>
          <Else>
            {() => (
              <EmptySet
                  color="grey-dark"
                  height={12}
                  width={12}
              />
            )}
          </Else>
        </If>
      </div>
      <div className="provider-selector__menu__item__full-name">
        {provider.readableName}
      </div>
    </Item>
  )
}

  ProviderItem.propTypes = {
    onChangeProvider: PropTypes.func.isRequired,
    provider: PropTypes.object.isRequired,
  }


export default ProviderItem;